import React from "react";
import BaseLayout from "../layouts/base";
import { apiBaseUri } from "../config";
import csc from "../assets/CSC.png";
import digital from "../assets/Digital_India_logo.png";

export default function LoginPage() {
  return (
    <div className="bg-[#E8F6FC] w-screen h-screen centered-page">
      <div className="flex flex-col gap-y-3 p-8 rounded-xl bg-white">
        <div className="flex justify-between items-center w-full space-x-4 mt-4">
          <img alt="" src={csc} className="h-7 sm:h-10 md:h-12" />
          <img alt="" src={digital} className="h-7 sm:h-10 md:h-12" />
        </div>
        <h1 className="text-3xl font-bold mb-5">IIBF Admin Portal</h1>
        <form
          action={`${apiBaseUri}/admin-login`}
          method="post"
          className="flex flex-col gap-y-3 w-full max-w-[600px]"
        >
          <input
            type="text"
            name="email"
            placeholder="Email"
            className="input-primary"
          />
          <input
            type="password"
            name="password"
            placeholder="Password"
            className="input-primary"
          />
          <input type="submit" className="btn-primary" value="Login" />
        </form>
      </div>
    </div>
  );
}
